module.exports = __webpack_public_path__ + "static/media/casos-clinicos.01134f62.jpg";